// Currency → accent color mapping.
//
// The four seeded non-base currencies (USD, EUR, MAD) plus base (MRU)
// have fixed accent slots so the same currency reads the same color on
// every screen — dashboard card, balance chip, chart segment, list-row
// avatar. Owner-added currencies beyond the fixed set hash into the
// remaining accent slots (purple/blue/green already claimed → cycle
// through teal, orange, pink, yellow).
//
// MRU (base) is deliberately the "structural" one: dark ink, no accent.
// Value/cash/debt colour semantics live elsewhere (--in / --out /
// --danger tokens); this file is currency IDENTITY only, never
// direction. See D-025 and design_handoff §"Direction is never carried
// by colour alone".

const FIXED: Record<string, string> = {
  MRU: 'currency--mru',
  USD: 'currency--usd',
  EUR: 'currency--eur',
  MAD: 'currency--mad',
};

const CYCLE = [
  'currency--teal',
  'currency--orange',
  'currency--pink',
  'currency--yellow',
  'currency--purple',
  'currency--blue',
  'currency--green',
];

// Deterministic pick from CYCLE for a non-seeded currency code.
function hashPick(code: string): string {
  let h = 0;
  for (let i = 0; i < code.length; i++) {
    h = (h * 31 + code.charCodeAt(i)) >>> 0;
  }
  const cls = CYCLE[h % CYCLE.length];
  return cls ?? 'currency--purple';
}

export function currencyClass(code: string | null | undefined): string {
  if (!code) return 'currency--mru';
  const upper = code.toUpperCase();
  return FIXED[upper] ?? hashPick(upper);
}
